import { useState, useEffect, useCallback } from "react";

const DebouncedInput = ({
    value = "",
    onChange,
    delay = 300,
    placeholder = "",
    className = "form-control",
    id,
    type = "text",
    ...props
}) => {
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (onChange && inputValue !== value) {
                onChange(inputValue);
            }
        }, delay);

        return () => clearTimeout(timeoutId);
    }, [inputValue, delay, onChange, value]);

    const handleChange = useCallback((e) => {
        setInputValue(e.target.value);
    }, []);

    return (
        <input
            type={type}
            className={className}
            id={id}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleChange}
            {...props}
        />
    );
};

export default DebouncedInput;
